import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams";
import moment from "moment";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_UPDATES_LOADING = "saga/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_TABLE_DATA_LOADING = "saga/SET_TABLE_DATA_LOADING";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_CURRENT_USER_FAILURE = "saga/FETCH_CURRENT_USER_FAILURE";
export const FETCH_CHART = "saga/FETCH_CHART";
export const FETCH_CHART_SUCCESS = "saga/FETCH_CHART_SUCCESS";
export const FETCH_CHART_FAILURE = "saga/FETCH_CHART_FAILURE";
export const FETCH_GRAPH = "saga/FETCH_GRAPH";
export const FETCH_GRAPH_SUCCESS = "saga/FETCH_GRAPH_SUCCESS";
export const FETCH_GRAPH_FAILURE = "saga/FETCH_GRAPH_FAILURE";
export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_TABLE_DATA_FAILURE = "saga/FETCH_TABLE_DATA_FAILURE";
export const FETCH_FILTERS = "saga/FETCH_FILTERS";
export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_FILTERS_FAILURE = "saga/FETCH_FILTERS_FAILURE";
export const CHANGE_TOGGLE = "sagas/CHANGE_TOGGLE";
export const CHANGE_PERCENTAGE_TOGGLE = "sagas/CHANGE_PERCENTAGE_TOGGLE";
export const CHANGE_TOGGLE_SUCCESS = "sagas/CHANGE_TOGGLE_SUCCESS";

export const UPDATE_CHART = "saga/UPDATE_CHART";
export const UPDATE_CHART_SUCCESS = "saga/UPDATE_CHART_SUCCESS";
export const UPDATE_CHART_FAILURE = "saga/UPDATE_CHART_FAILURE";

export const SET_DATES = "saga/SET_DATES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const RESET_TABLE_DATA = "sagas/RESET_TABLE_DATA";
export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_PERIOD_TYPE = "sagas/UPDATE_PERIOD_TYPE";
export const UPDATE_PERIOD_TYPE_SELECTED = "sagas/UPDATE_PERIOD_TYPE_SELECTED";
export const YEAR_OVER_YEAR_LOADING = "sagas/YEAR_OVER_YEAR_LOADING";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  getTableData: createAction(FETCH_TABLE_DATA),
  updateData: createAction(UPDATE_CHART),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updatePeriodType: createAction(UPDATE_PERIOD_TYPE),
  onChangeToggle: createAction(CHANGE_TOGGLE),
  onChangePercentageToggle: createAction(CHANGE_PERCENTAGE_TOGGLE)
};

export default function* watchCheckIn() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(FETCH_TABLE_DATA, fetchModalTableData);
  yield takeLatest(UPDATE_CHART, updateData);
  yield takeLatest(UPDATE_PERIOD_TYPE, updatePeriodTypeAndLoad);
  yield takeLatest(CHANGE_TOGGLE, onChangeToggle);
}

export function* updatePeriodTypeAndLoad(payload) {
  yield put({ type: UPDATE_PERIOD_TYPE_SELECTED, payload: payload.payload });
  yield put({ type: YEAR_OVER_YEAR_LOADING, payload: true });
  try {
    yield call(fetchUpdateGraph);
    yield put({ type: YEAR_OVER_YEAR_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateChart() {
  const allSagas = [fetchUpdateChart(), fetchUpdateGraph()];

  try {
    yield put({ type: SET_FILTERS_DIRTY, payload: false });
    yield all(allSagas);
  } catch (error) {
    console.error(error);
  }
}

export function* getCurrentUserData(data) {
  yield put({
    type: FETCH_CURRENT_USER_SUCCESS,
    payload: { currentUser: data.payload.currentUser, numberOfMonths: data.payload.numberOfMonths }
  });
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  const endDate = yield select((state) => state.checkIn.currentUser.calendarEndDate);
  yield put({
    type: SET_DATES,
    payload: {
      startDate: moment(endDate).startOf("month").format("YYYY-MM-DD"),
      endDate: endDate
    }
  });

  const allSagas = [fetchChart(), fetchGraph()];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateData() {
  yield put({ type: SET_UPDATES_LOADING, payload: true });
  const allSagas = [updateChart()];

  try {
    yield all(allSagas);
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getCommonApiParams() {
  return yield select((state) => {
    const {
      currentUser: { organization_id, current_object_id, current_location_id, current_region_id },
      selectedRequestDates: { endDate, startDate }
    } = state.checkIn;

    if (
      !endDate &&
      !startDate &&
      !organization_id &&
      !current_object_id &&
      !current_location_id &&
      !current_region_id
    )
      return;

    return {
      end_date: endDate,
      start_date: startDate,
      organization_id: organization_id.toString(),
      object_id: current_object_id.toString(),
      location_id: current_location_id.toString(),
      region_id: current_region_id.toString()
    };
  });
}

export function* fetchChart() {
  const { end_date, start_date, organization_id, object_id, location_id, region_id } =
    yield getCommonApiParams();

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/checkins_chart/checkins_heatmap",
      {
        organization_id,
        location_id,
        region_id,
        object_id,
        start_date,
        end_date
      }
    );

    yield put({ type: FETCH_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_CHART_FAILURE, error });
  }
}

export function* fetchGraph() {
  const periodType = yield select((state) => state.checkIn.periodType);
  const { end_date, start_date, organization_id, object_id, location_id, region_id } =
    yield getCommonApiParams();

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/checkins_chart/total_checkins",
      {
        organization_id,
        location_id,
        region_id,
        object_id,
        period_type: periodType.toLowerCase().toString(),
        start_date,
        end_date
      }
    );

    yield put({ type: FETCH_GRAPH_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GRAPH_FAILURE, error });
  }
}

export function* fetchUpdateGraph() {
  const periodType = yield select((state) => state.checkIn.periodType);
  const { end_date, start_date, organization_id, object_id, location_id, region_id } =
    yield getCommonApiParams();

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/checkins_chart/total_checkins",
      {
        organization_id,
        location_id,
        region_id,
        object_id,
        period_type: periodType.toLowerCase().toString(),
        start_date,
        end_date
      }
    );

    yield put({ type: FETCH_GRAPH_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_GRAPH_FAILURE, error });
  }
}

export function* fetchUpdateChart() {
  const {
    currentUser: {
      organization_id: id,
      current_object_id: objectId,
      current_location_id: locationId,
      current_region_id: regionId
    },
    groupByWeekDay,
    showPercentage,
    selectedRequestDates: { startDate, endDate }
  } = yield select((state) => state.checkIn);

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/checkins_chart/checkins_heatmap",
      {
        organization_id: id.toString(),
        location_id: locationId.toString(),
        region_id: regionId.toString(),
        object_id: objectId.toString(),
        start_date: startDate,
        end_date: endDate,
        group_by_week_day: groupByWeekDay,
        show_percentage: showPercentage
      }
    );

    yield put({ type: UPDATE_CHART_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: UPDATE_CHART_FAILURE, error });
  }
}

export function* fetchModalTableData(payload) {
  yield put({ type: SET_TABLE_DATA_LOADING, payload: true });
  const { end_date, start_date, organization_id, object_id, location_id, region_id } =
    yield getCommonApiParams();

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/attendance/checkins_chart/heatmap_modal_data",
      {
        organization_id,
        location_id,
        region_id,
        object_id,
        tableDataUid: payload.payload.tableDataUid,
        start_date,
        end_date
      }
    );

    yield put({ type: FETCH_TABLE_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
    yield put({ type: FETCH_TABLE_DATA_FAILURE, error });
  }
}

function* onChangeToggle(data) {
  yield put({ type: CHANGE_TOGGLE_SUCCESS, payload: data.payload });
  yield put({ type: SET_FILTERS_DIRTY, payload: true });
}
